// @ts-nocheck
import { useSelector as useReduxSelector } from "react-redux";
import { cartProducts } from "../../stores/cart/cartSlice";
import SummaryDetails from "../../components/SummaryDetails";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguageContext } from "../../context/languageContext";
import { FaChevronLeft, FaShoppingBag } from "react-icons/fa";

const Cart = () => {
    const cart = useReduxSelector(cartProducts);
    const navigate = useNavigate();
    const { t } = useLanguageContext();
    const reduxBusinessId = useReduxSelector((state) => state.business.businessId);
    const businessId = reduxBusinessId || 1;

    if (!cart || cart.length === 0) {
        return (
            <div className="main-content flex items-center justify-center p-6 text-sharp">
                <div className="w-full max-w-sm text-center space-y-6 animate-app-reveal">
                    <div className="mx-auto w-24 h-24 flex items-center justify-center rounded-3xl bg-slate-50 border border-slate-100 shadow-sm">
                        <FaShoppingBag className="text-3xl text-slate-200" />
                    </div>
                    <div className="space-y-2">
                        <h1 className="text-2xl font-clash text-slate-900 tracking-tight">{t("cartTitle")}</h1>
                        <p className="text-sm text-slate-500 font-medium leading-relaxed px-6">
                            {t("cartDescription")}
                        </p>
                    </div>
                    <button
                        onClick={() => navigate(`/home?businessid=${businessId}`)}
                        className="btn-app btn-primary-app w-full text-sm tracking-widest uppercase"
                    >
                        {t("Browse Menu")}
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="flex-1 bg-white text-sharp">
            {/* Minimal Mobile Header */}
            <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between sticky top-16 bg-white/80 backdrop-blur-xl z-20">
                <div className="flex items-center gap-3">
                    <button
                        onClick={() => navigate(-1)}
                        className="w-8 h-8 flex items-center justify-center rounded-full bg-slate-50 text-slate-900 active:scale-90 transition-transform"
                    >
                        <FaChevronLeft size={14} />
                    </button>
                </div>
                <div className="text-xs font-black uppercase tracking-widest text-slate-400">
                    {cart.reduce((acc, item) => acc + (item.amount || 1), 0)} {t("Items")}
                </div>
            </div>

            <div className="flex-1 max-w-2xl mx-auto w-full">
                <SummaryDetails />
            </div>
        </div>
    );
};

export default Cart;
